export default __webpack_public_path__ + "static/media/brandGuidelinesImagePage19.aafd83a4.png";